import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  input: {
    display: 'none',
  },
}));

export default useStyles;
